'use strict';


function redirect_to_hub_login(hub_web_url) {
	const next_url = window.location.href;
	const params = new URLSearchParams({"next": next_url}).toString();
	window.location.replace(`${hub_web_url}/login?${params}`);
}


// Converted from CoffeeScript to JavaScript - ETNA Authenticator Identity Service
intra_module.provider("identity", ['hub_api_url', 'hub_web_url', function(hub_api_url, hub_web_url) {
	const identity_api_url = hub_api_url + '/auth/identity';
    var open_modal = true;

    this.openModal = function(bool) {
        open_modal = bool;
    };

    this.$get = ['$resource', '$rootScope', '$q', 'loginModal', function($resource, $rootScope, $q, loginModal) {
        
        var authEvent = function(event_name) {
            $rootScope.$broadcast("auth:" + event_name);
        };

        var Identity = $resource(identity_api_url, null, {
            get: {
                method: "GET",
                withCredentials: true,
                interceptor: {
                    responseError: function(rejection) {
                        if (rejection.data.close != null) {
                            authEvent('close');
                            if (open_modal) {
                                loginModal.open('close');
                            }
                        }
                        return $q.reject(rejection);
                    }
                }
            },
            login: {
                method: "POST",
                withCredentials: true,
                interceptor: {
                    response: function(response) {
                        authEvent('login');
                        return response;
                    }
                }
            },
            logout: {
                method: "DELETE",
                withCredentials: true,
                interceptor: {
                    response: function(response) {
                        if (response.data.login != null) {
                            authEvent('login');
                        } else {
                            authEvent('logout');
                            if (open_modal) {
								redirect_to_hub_login(hub_web_url);
								// previous logic here was to open the Login modal.
                                // loginModal.open('login');
                            }
                        }
                        return response;
                    }
                }
            }
        });

        var me = Identity.get();

        $rootScope.$on("http:401", function() {
            me.$logout();
        });

        return me;
    }];

    return this;
}]);
